module.exports = __webpack_public_path__ + "img/ticket_ex1.95f90b2f.svg";